/*
 * The homepage's reveal on scroll (session A5b). A labelled IMPROVEMENT on the
 * live theme, which has none; Luke may veto it (it is registered with the
 * mother session).
 *
 * Every element marked [data-fz-reveal] that is still BELOW the screen when
 * this runs is armed (hidden 16 px low) and settles into place the first time
 * it enters the screen. The CSS lives in snippets/fz-home-heading.liquid.
 *
 * What keeps it harmless:
 *   - Anything already on screen, or above it, is left alone, so nothing the
 *     shopper can see blinks, and the hero and the LCP image are never
 *     touched: they are on screen when this runs.
 *   - Without this script, or with prefers-reduced-motion, the page is simply
 *     static and complete.
 *   - Automated browsers (navigator.webdriver) are not armed, so the verify
 *     loop's and the likeness tool's full-page captures show the settled page
 *     rather than sections still waiting to be scrolled to.
 *   - One IntersectionObserver, unobserving each element once shown, and no
 *     input listeners, so it costs INP nothing. Transform and opacity only.
 *   - An element revealed stays revealed; scrolling back up does nothing.
 */

const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function arm() {
  if (reduce || navigator.webdriver || !("IntersectionObserver" in window)) return;

  const pending = [
    ...document.querySelectorAll('[data-fz-reveal]:not([data-fz-reveal="armed"], [data-fz-reveal="shown"])'),
  ];
  if (!pending.length) return;

  const fold = window.innerHeight;
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute("data-fz-reveal", "shown");
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0 },
  );

  for (const element of pending) {
    if (element.getBoundingClientRect().top < fold) continue;
    element.setAttribute("data-fz-reveal", "armed");
    observer.observe(element);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", arm, { once: true });
} else {
  arm();
}
